// Microsoft Clarity — loaded ONLY after cookie consent ("Accepter").
const CONSENT_KEY = "idv_cookie_consent";

export function getConsent() {
  try { return localStorage.getItem(CONSENT_KEY); } catch (e) { return null; }
}

export function setConsent(value) {
  try { localStorage.setItem(CONSENT_KEY, value); } catch (e) {}
}

export function loadClarity() {
  if (typeof window === "undefined" || window.__clarityLoaded) return;
  window.__clarityLoaded = true;
  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", "yoxfqa0417");
  window.clarity("consent");
}

// Fires a Clarity custom event — no-op until consent is given and Clarity is loaded.
// Mirrors a whitelisted subset to Google Analytics 4 (same event names).
export function clarityEvent(name) {
  try {
    if (typeof window !== "undefined" && typeof window.clarity === "function") {
      window.clarity("event", name);
    }
  } catch (e) {}
  if (isGaEvent(name)) gaEvent(name);
}

// ---- Google Analytics 4 (gtag.js) + Consent Mode v2 ----
const GA_ID = "G-V6TGJNVEMK";

// GA must never run on the admin area nor for an authenticated admin.
export function isAdminContext() {
  try {
    if (typeof window === "undefined") return true;
    if ((window.location.pathname || "").startsWith("/admin")) return true;
    return localStorage.getItem("idv_is_admin") === "1";
  } catch (e) { return false; }
}

export function setAdminFlag() {
  try { localStorage.setItem("idv_is_admin", "1"); } catch (e) {}
}

export function loadGA() {
  if (typeof window === "undefined" || window.__gaLoaded || isAdminContext()) return;
  window.__gaLoaded = true;
  const s = document.createElement("script");
  s.async = 1;
  s.src = "https://www.googletagmanager.com/gtag/js?id=" + GA_ID;
  document.head.appendChild(s);
  if (typeof window.gtag === "function") window.gtag("config", GA_ID);
}

export function updateGAConsent(granted) {
  try {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const v = granted ? "granted" : "denied";
    window.gtag("consent", "update", {
      analytics_storage: v,
      ad_storage: v,
      ad_user_data: v,
      ad_personalization: v,
    });
  } catch (e) {}
}

const GA_EVENTS = new Set([
  "clic_cta_accueil",
  "pacte_valide",
  "generation_lancee",
  "prix_affiches",
  "clic_offre_depart",
  "clic_offre_lancement",
  "clic_offre_acceleration",
]);

function isGaEvent(name) {
  if (GA_EVENTS.has(name)) return true;
  const m = /^question_(\d+)$/.exec(name || "");
  return !!(m && Number(m[1]) >= 1 && Number(m[1]) <= 13);
}

function gaEvent(name) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function" && !isAdminContext()) {
      window.gtag("event", name);
    }
  } catch (e) {}
}

// ---- First-touch referral capture (?ref=) ----
const REF_KEY = "idv_ref";

export function captureRef() {
  try {
    if (typeof window === "undefined") return;
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref && !localStorage.getItem(REF_KEY)) localStorage.setItem(REF_KEY, ref.slice(0, 120));
  } catch (e) {}
}

export function getRef() {
  try { return localStorage.getItem(REF_KEY) || undefined; } catch (e) { return undefined; }
}


// Crisp — loaded only after cookie consent. Chat bubble is kept fully hidden (incl. iPhone).
export function loadCrisp() {
  if (typeof window === "undefined" || window.__crispLoaded) return;
  window.__crispLoaded = true;
  window.$crisp = [];
  window.CRISP_WEBSITE_ID = "1eca1895-850d-47c4-b5bb-69cf01615988";
  window.$crisp.push(["do", "chat:hide"]);
  window.$crisp.push(["on", "session:loaded", function () { window.$crisp.push(["do", "chat:hide"]); }]);
  window.$crisp.push(["on", "chat:opened", function () { window.$crisp.push(["do", "chat:hide"]); }]);
  const d = document;
  const s = d.createElement("script");
  s.src = "https://client.crisp.chat/l.js";
  s.async = 1;
  d.getElementsByTagName("head")[0].appendChild(s);
  // Bulletproof hide regardless of Crisp runtime / device (iPhone included).
  const st = d.createElement("style");
  st.setAttribute("data-crisp-hide", "true");
  st.textContent = ".crisp-client{display:none !important;visibility:hidden !important;}";
  d.head.appendChild(st);
}
